import Box from "@mui/material/Box";
import { setInncodes } from "components/app/App.slice";
import AsyncAutocomplete from "components/common/Autocomplete";
import AutocompleteInncode from "components/common/AutocompleteInncode";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import Typography from "components/common/Typography";
import { clearUserDetail } from "components/features/MyPlanDetails/MyPlanDetails.slice";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { mapUserToInncode, setShowAddInncodeDialog } from "./sme.slice";

const AddInncodeDialog = (props: any) => {
  const dispatch = useAppDispatch();
  const [assigneeList, setAssigneeList] = useState<any>([]);
  const [btnDisabled, setBtnDisabled] = useState<boolean>(true);
  const { showAddInncodeDialog } = useAppSelector((state) => state.sme);
  const {
    register,
    reset,
    handleSubmit,
    setValue,
    setError,
    clearErrors,
    watch,
    formState: { errors }
  } = useForm({ defaultValues: { user: [], innCode: "" } });
  const watchUser = watch("user");
  const watchInncode = watch("innCode");

  useEffect(() => {
    register("user", { required: true });
    register("innCode", { required: true });
  }, []);

  const handleClose = () => {
    reset();
    dispatch(setInncodes([]));
    dispatch(clearUserDetail());
    dispatch(setShowAddInncodeDialog(false));
  };

  const handleChange = (v: any) => {
    setValue("innCode", v?.innCode || "");
    setValue("user", []);
    setAssigneeList([]);
  };

  useEffect(() => {
    if (!showAddInncodeDialog) {
      reset();
    }
  }, [showAddInncodeDialog]);

  useEffect(() => {
    if (Object.keys(errors).length > 0 || watchInncode?.trim().length < 1 || watchUser?.length < 1) {
      setBtnDisabled(true);
    } else {
      setBtnDisabled(false);
    }
  }, [watchInncode, watchUser]);

  const onSubmit = (data: any) => {
    if (!data?.user) {
      setError("user", { type: "required", message: "You will need to select a user." });
      return;
    }
    if (data?.user?.length > 1) {
      setError("user", { type: "maxLength", message: "Only one user should be assigned" });
      return;
    } else {
      const payload = { mappings: [{ hltId: data?.user[0], innCode: data?.innCode }] };
      dispatch(mapUserToInncode({ groupId: props?.listId, payload, view: "inncodes", type: "add" }));
      reset();
      dispatch(setInncodes([]));
      dispatch(clearUserDetail());
    }
  };

  return (
    <DialogFormation
      openDialog={showAddInncodeDialog}
      handleClose={handleClose}
      title="Add Inncode"
      actionConfig={
        <div className="modal-config-wrapper">
          <Button disabled={btnDisabled} label="Add Inncode" onClick={handleSubmit(onSubmit)} />
        </div>
      }
    >
      <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{ textAlign: "left", width: "100%" }}>
        <AutocompleteInncode onSelect={handleChange} />
        <Box sx={{ height: "24px" }} />
        <AsyncAutocomplete
          assigneeList={assigneeList}
          disabled={!watchInncode}
          showIcon={false}
          multiple={false}
          getUserDetail={(val) => {
            setValue("user", val);
            setAssigneeList(val);
            clearErrors();
          }}
          placeholder="Enter the user"
          searchParams={{ innCode: watchInncode }}
        />
        {errors?.user && (
          <Typography variant="label" color={tokens.Text.Feedback.Alert}>
            {errors?.user?.message ?? "This field is required to be completed. "}
          </Typography>
        )}
      </Box>
    </DialogFormation>
  );
};

export default AddInncodeDialog;
